module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"error_tipo_fachada":"Se debe seleccionar el tipo de fachada para poder calcular el precio por defecto","error_intensidad_transito":"Se debe seleccionar la intensidad de tránsito para poder calcular el precio por defecto"}}')
  delete Component.options._Ctor
}
